export default __webpack_public_path__ + "static/media/copy.f347a1de.svg";